import { Box, Container, H1, Image, Lead, Section } from 'react-components';
import { PaperPlaneSection } from './components/paper-plane-section';
import { Partners } from './sections/about-us/Partners';
import { TeamMembers } from './sections/about-us/TeamMembers';
import { WhatOthersSayAboutUs } from './sections/about-us/WhatOthersSayAboutUs';
import team from './sections/assets/team.jpg';
import { OurCommunity } from './sections/OurCommunity';

export const AboutUsPage: React.FunctionComponent = () => {
  return (
    <>
      <Section bg={{ _: 'blacks.black100', sm: 'success.success50' }}>
        <Container pt={{ _: '9rem', sm: '6rem' }} pb="6rem">
          <Box pr="15%">
            <H1 my={0}>Making blockchain accessible for everyone</H1>
            <Lead color="black" mt="3rem" mb={0}>
              pier wallet is your place from which to embark for exciting new places and your safe
              harbour to return to. pier wants to enable and empower more people to participate in
              blockchain technology. From crypto investing to NFT art and gaming, we want to lower
              entry barriers while maintaining the principle of self-ownership when transacting with
              digital assets.
            </Lead>
          </Box>
        </Container>
      </Section>
      <Section bg="success.success50">
        <Container $noPadding={true}>
          <Image
            src={team.src}
            alt="pier team"
            width="100%"
            mb="-4px" // don't ask me why
          />
        </Container>
      </Section>
      <TeamMembers />
      <WhatOthersSayAboutUs />
      <Partners />
      <PaperPlaneSection title="Want to know more?" lead="We look forward to hearing from you!" />
      <OurCommunity />
    </>
  );
};
